<template>
  <div class="" v-if="basalamProduct != null">
    <div class="btn btn-warning rounded-pill">وضعیت: {{ basalamProduct.status.title }}</div>
  </div>
</template>

<script>
export default {
  name: "BasalamProductStatus",
  props: {
    basalamProduct: {
      default: null
    }
  }
}
</script>


<style scoped>

</style>